import { render, staticRenderFns } from "./ShippingState.vue?vue&type=template&id=779f7a50&scoped=true"
import script from "./ShippingState.vue?vue&type=script&lang=js"
export * from "./ShippingState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779f7a50",
  null
  
)

export default component.exports